<template>
    <div>
        <b-card-group deck class="form-search-multiselect__controls" v-if="isControls">
            <b-card no-body>
                <b-list-group flush>
                    <b-list-group-item
                        v-if="!hideSelectAll"
                        class="btn btn-default form-search-multiselect__group-item"
                        @click="onSelectAll"
                    >
                        <div class="d-flex align-items-center">
                            <font-awesome-icon
                                class="form-search-multiselect__icon"
                                :icon="['fas', 'check']"
                            ></font-awesome-icon>
                            <span> Select All </span>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item
                        class="btn btn-default form-search-multiselect__group-item"
                        @click="onUnselectAll"
                    >
                        <div class="d-flex align-items-center">
                            <font-awesome-icon
                                class="form-search-multiselect__icon"
                                :icon="['fas', 'xmark']"
                            ></font-awesome-icon>
                            <span> Unselect All </span>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-card>
        </b-card-group>
        <b-card-group
            deck
            v-if="filteredSelectedOptions.length"
            class="form-search-multiselect__selected-options"
        >
            <b-card no-body>
                <b-list-group
                    flush
                    class="form-search-multiselect__selected-options-group p-1"
                >
                    <b-list-group-item
                        active
                        v-for="option in filteredSelectedOptions"
                        :key="option.value"
                        @click="onOptionUnselect(option.value)"
                        class="btn primary form-search-multiselect__group-item mb-1"
                        ><div
                            class="d-flex align-items-center form-search-multiselect__group-item-text-wrapper selected-scroll"
                        >
                            <font-awesome-icon
                                class="form-search-multiselect__icon"
                                :icon="['fas', 'xmark']"
                            ></font-awesome-icon>
                            <div
                                :class="{
                                    'form-search-multiselect__group-item-text': true,
                                    'opacity-75': option.disabled,
                                    'font-italic': option.disabled,
                                }"
                            >
                                {{ option.text }}
                            </div>
                        </div></b-list-group-item
                    >
                </b-list-group>
            </b-card>
        </b-card-group>
        <div v-if="isSearchable" class="form-search-multiselect__search-bar">
            <b-form-input
                v-model="searchValue"
                placeholder="Search..."
            ></b-form-input>
        </div>
        <b-card-group
            deck
            v-if="filteredOptions.length"
            class="form-search-multiselect__options"
        >
            <b-card no-body>
                <b-list-group
                    flush
                    class="form-search-multiselect__options-group"
                >
                    <b-list-group-item
                        class="btn btn-default form-search-multiselect__group-item form-search-multiselect__options-group-item"
                        v-for="option in filteredOptions"
                        :key="option.value"
                        @click="onOptionSelect(option.value)"
                        ><div
                            class="d-flex align-items-center form-search-multiselect__group-item-text-wrapper options-scroll"
                        >
                            <div
                                :class="{
                                    'form-search-multiselect__group-item-text': true,
                                    'text-muted': option.disabled,
                                    'font-italic': option.disabled,
                                }"
                            >
                                {{ option.text }}
                            </div>
                        </div></b-list-group-item
                    >
                </b-list-group>
            </b-card>
        </b-card-group>
    </div>
</template>

<script>
import FormInput from '../form-input/form-input.vue';

export default {
    name: 'SearchMultiselectCard',
    components: {
        FormInput,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Array,
            default: () => [],
        },
        isSearchable: {
            type: Boolean,
            default: true,
        },
        isControls: {
            type: Boolean,
            default: true,
        },
        applyDefaultSort: {
            type: Boolean,
            default: true
        },
        hideSelectAll: {
            type: Boolean,
            default: false
        }     
    },
    data() {
        return {
            searchValue: '',
            internalOptions: [],
            selectedOptions: this.value || [],
        };
    },
    computed: {
        filteredSelectedOptions() {
            let options = this.internalOptions
                .filter((option) => option.selected)

            if(this.applyDefaultSort) {
                options = options.sort((a, b) => {
                    const { text, disabled } = a
                    const result = text.localeCompare(b.text)
                    if (result === 0) {
                        if (disabled === b.disabled) return 0;
                        else if (!disabled) return -1;
                        else return 1;
                    }
                    return result;
                });
            }
            return [...options.filter((option) => !option.disabled), ...options.filter((option) => option.disabled)];
        },
        filteredOptions() {
            let options = this.internalOptions.filter(
                (option) =>
                    option.text
                        .toLowerCase()
                        .indexOf(this.searchValue.toLowerCase()) != -1 &&
                    !option.selected
            )
            if(this.applyDefaultSort) {
                options = options.sort((a, b) => {
                    const { text, disabled } = a
                    const result = text.localeCompare(b.text)
                    if (result === 0) {
                        if (disabled === b.disabled) return 0;
                        else if (!disabled) return -1;
                        else return 1;
                    }
                    return result;
                });
            }
           
            return [...options.filter((option) => !option.disabled), ...options.filter((option) => option.disabled)];
        },
    },
    methods: {
        onOptionSelect(value) {
            setTimeout((_) => this.toggleOption(value, true));
        },
        onOptionUnselect(value) {
            setTimeout((_) => this.toggleOption(value, false));
        },
        onSelectAll() {
            this.internalOptions.forEach((option) =>
                this.toggleOption(option.value, true)
            );
        },
        onUnselectAll() {
            this.internalOptions.forEach((option) =>
                this.toggleOption(option.value, false)
            );
        },
        toggleOption(value = '', selected = false) {
            const option = this.internalOptions.find(
                (option) => option.value === value
            );

            if (option) {
                option.selected = selected;
                this.$emit('input', [
                    ...this.internalOptions
                        .filter((option) => option.selected)
                        .map((option) => option.value),
                ]);
            }
        },
    },
    watch: {
        options: {
            immediate: true,
            handler(options) {
                this.internalOptions = [...options].map((option) => ({
                    ...option,
                    selected: this.value.includes(option.value),
                }));
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

$selected-button-color: #08c;
$primary-color: #0d47a1;
$scroll-background-color: #f5f5f5;
$border-color: #d8d8d8;
$font-color: #fff;

@mixin scroll-bar() {
    scrollbar-color: $primary-color $scroll-background-color;

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px $border-color;
        border-radius: 10px;
        background-color: $scroll-background-color;
        border-right-width: 1px;
        border-left-width: 1px;
    }

    &::-webkit-scrollbar {
        width: 8px;
        height: 6px;
        background-color: $scroll-background-color;
        border-right-width: 1px;
        border-left-width: 1px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: $primary-color;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
}

.primary {
    color: $font-color !important;
    background-color: $primary-color !important;
    border-color: $primary-color !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
        0 1px 1px rgba(0, 0, 0, 0.075) !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;

    &:hover {
        background-color: #0a377e !important;
        border-color: #093272 !important;
    }

    > :deep(label) {
        color: $font-color !important;
    }
}

.form-search-multiselect {
    &__icon {
        height: 1rem !important;
        width: 1rem !important;
        margin-right: 0.6rem;
    }

    &__controls {
        margin-bottom: 0.3rem;
    }

    &__selected-options {
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;

        &-group {
            scrollbar-width: thin;
            overflow-y: auto;
            max-height: 25vh;
            @include scroll-bar;
        }
    }

    &__search-bar {
        padding: 0.4rem 0;
        margin: 0.3rem 0;
    }

    &__options {
        margin-top: 0.3rem;

        &-group {
            scrollbar-width: thin;
            overflow-y: auto;
            max-height: 25vh;
            @include scroll-bar;
        }
    }

    &__options-group-item {
        &:active {
            background-color: #e6e6e6 !important;
        }
    }

    &__group-item {
        display: flex;
        padding: 0.5rem !important;
        height: 2.5rem;

        &-text-wrapper {
            scrollbar-width: thin;
            text-align: left;
            width: max-content;
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            width: 100%;
        }

        &-text {
            padding: 0 0.2rem;
            width: max-content;
        }
    }
}

.options-scroll {
    @include scroll-bar;

    &::-webkit-scrollbar {
        border-radius: 10px;
        border-color: rgba(255, 255, 255, 0.15);
    }

    &::-webkit-scrollbar-track {
        border-color: rgba(255, 255, 255, 0.15);
    }
}

.selected-scroll {
    scrollbar-color: lightgray $scroll-background-color;
    @include scroll-bar;
    &::-webkit-scrollbar-track {
        border-color: $primary-color;
        &:hover {
            border-color: #0a377e;
        }
    }

    &::-webkit-scrollbar {
        border-radius: 10px;
        border-color: $primary-color;
        &:hover {
            border-color: #0a377e;
        }
    }

    &::-webkit-scrollbar-thumb {
        background-color: lightgray;
    }
}

:deep(.list-group-item) {
    border: none !important;
    box-shadow: none !important;

    &:first-child {
        border: none !important;
    }
}

@media (max-width: 470px) {
    .form-search-multiselect {
        &__selected-options-group {
            max-height: 15vh;
        }

        &__options-group {
            max-height: 15vh;
        }
    }
}
</style>
